export const convertToUTC = (date) => {
	// if the date is invalid, just return early
	if (isNaN(date.getTime())) {
		return;
	}

	const isoDate = date.toISOString();
	return `${isoDate.substr(0, 10)} ${isoDate.substr(11, 8)}`;
};
